import React from "react";
import { Icon } from "@culturehq/components";
import { ManualStatus } from "./EffectsSDKCameraRecorder";

interface MobileOptionsProps {
  manualStatus: ManualStatus;
  onFinishRecord: () => void;
  onPause: () => void;
  onResume: () => void;
  onStartCountdown: () => void;
}

const MobileOptions: React.FC<MobileOptionsProps> = ({
  manualStatus,
  onFinishRecord,
  onPause,
  onResume,
  onStartCountdown
}) => {
  if (manualStatus === "recording") {
    return (
      <>
        <div className="Mobile-Record-Button" onClick={onPause} data-testid="mobile-pause-option">
          <Icon className="Mobile-Record-Button__icon" icon="pause" />
        </div>
        <div className="Mobile-Record-Button" onClick={onFinishRecord} data-testid="mobile-finish-option">
          <div className="finish-icon" />
        </div>
      </>
    );
  }

  if (manualStatus === "idle") {
    return (
      <div className="Mobile-Record-Button" onClick={onStartCountdown} data-testid="mobile-record-option">
        <Icon className="record-icon" icon="record" />
      </div>
    );
  }

  if (manualStatus === "paused") {
    return (
      <div className="Mobile-Record-Button" onClick={onResume} data-testid="mobile-resume-option">
        <Icon className="record-icon" icon="record" />
      </div>
    );
  }

  return <></>;
};

export default MobileOptions;
